export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uvítací bonus"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zkus své štěstí!"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vyhrál jsi"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Otoč kolem a získej testovací prostředky pro prozkoumání všech funkcí platformy."])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tyto prostředky jsou pro testování."])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ponoř se a zažij všechny funkce."])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Otočit"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vybrat"])}
}